import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, isDevMode, LOCALE_ID } from '@angular/core';
import localePt from '@angular/common/locales/pt';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { ConfirmationService, MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { httpHeaderInterceptor } from './app/config/http-header.interceptor';
import { TranslocoHttpLoader } from './transloco-loader';

registerLocaleData(localePt);

/**
 * Tema do portal.
 *
 * O Aura entrega o p-progressSpinner com quatro cores diferentes
 * (`color.1` vermelho, `color.2` azul, `color.3` verde, `color.4` amarelo),
 * o que faz o spinner piscar colorido enquanto gira. Aqui os quatro tokens
 * apontam para a cor primaria, entao a animacao continua mas em cor unica,
 * igual em todas as telas. E token de tema, nao CSS sobrescrito.
 */
const LxHarvestPreset = definePreset(Aura, {
    components: {
        progressspinner: {
            colorScheme: {
                light: {
                    root: {
                        'color.1': '{primary.color}',
                        'color.2': '{primary.color}',
                        'color.3': '{primary.color}',
                        'color.4': '{primary.color}'
                    }
                },
                dark: {
                    root: {
                        'color.1': '{primary.color}',
                        'color.2': '{primary.color}',
                        'color.3': '{primary.color}',
                        'color.4': '{primary.color}'
                    }
                }
            }
        }
    }
});

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(TranslocoModule),
        MessageService,
        ConfirmationService,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([httpHeaderInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            theme: { preset: LxHarvestPreset, options: { darkModeSelector: '.app-dark' } },
            translation: {
                apply: 'Aplicar',
                clear: 'Limpar',
                today: 'Hoje',
                firstDayOfWeek: 0,
                dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
                dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
                dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                monthNames: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro'
                ],
                monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            }
        }), provideTransloco({
        config: {
          availableLangs: ['en','pt','es'],
          defaultLang: 'pt',
          // Remove this option if your application doesn't support changing language in runtime.
          reRenderOnLangChange: true,
          prodMode: !isDevMode(),
        },
        loader: TranslocoHttpLoader
      })
    ]
};
